import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TrackingService } from '../../../bdo/services/tracking.service';
import { TRACKING } from '../../../bdo/enums/trackingParts.enum';
import { v4 as uuidv4 } from 'uuid';

export interface HintTileConfig {
  borderTopColor: 'red' | 'green' | '';
  iconPath: string;
  iconWithBadge: boolean;
  text: string;
  linkText: string;
  linkType: 'primaryButton' | 'secondaryButton' | 'texticon' | '';
  linkPath: string; // Leave this empty to trigger the click event instead of navigating to a new page
  isDashboardTile: boolean;
  title?: string;
  trackingLocation?: string;
  trackingDestination?: string;
  accessibilityLabel?: string;
  accessibilityRole?: 'alert' | 'status' | '';
}

@Component({
    selector: 'bdo-hint-tile',
    templateUrl: './hint-tile.component.html',
    styleUrls: ['./hint-tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HintTileComponent implements OnInit {

  @Input() currentHintTileConfig: HintTileConfig;
  @Output() tileClicked: EventEmitter<void> = new EventEmitter<void>();
  public ariaHeadingId: string;

  constructor(
    private router: Router,
    private trackingService: TrackingService
  ) { }

  ngOnInit(): void {
    this.ariaHeadingId = 'hint-tile-heading-' + uuidv4();
  }

  public toTarget() {
    if (this.currentHintTileConfig.trackingLocation && this.currentHintTileConfig.trackingDestination) {
      this.trackingService.postSimpleTracking(this.currentHintTileConfig.trackingLocation, TRACKING.ACTION.GOTO, this.currentHintTileConfig.trackingDestination);
    }
    this.router.navigate([this.currentHintTileConfig.linkPath]);
  }
}
